import React from 'react';
import {
  StyleProp,
  Text,
  TextStyle,
  TouchableOpacity,
  View,
  ViewStyle,
} from 'react-native';
import {buttonsStyles} from '../boutonStyle';

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onPress: any;
  title: string;
  type?: string;
  styleBtnTxt?: StyleProp<TextStyle>;
  styleBtnOuter?: StyleProp<ViewStyle>;
  isDisable?: boolean;
  styleContainer?: StyleProp<ViewStyle>;
}
const PrimaryButton = ({
  onPress,
  title,
  type,
  styleBtnTxt,
  styleBtnOuter,
  isDisable,
  styleContainer,
}: Props) => (
  <View style={[buttonsStyles.container, styleContainer]}>
    {!type && (
      <TouchableOpacity
        disabled={isDisable}
        onPress={() => onPress(type)}
        style={[
          buttonsStyles.appButton,
          buttonsStyles.appButtonContainerBtn,
          styleBtnOuter,
        ]}>
        <Text style={styleBtnTxt}>{title}</Text>
      </TouchableOpacity>
    )}
    {type && (
      <TouchableOpacity
        disabled={isDisable}
        onPress={() => onPress(type)}
        style={[
          buttonsStyles.appButton,
          buttonsStyles.appButtonContainer,
          type && type === 'valider'
            ? buttonsStyles.validate
            : buttonsStyles.inValidate,
          styleBtnOuter,
          type && type === 'valider' ? buttonsStyles.btnValidate : null,
          isDisable && buttonsStyles.btnDisable,
        ]}>
        <Text style={styleBtnTxt}>{title}</Text>
      </TouchableOpacity>
    )}
  </View>
);

export default PrimaryButton;
